@if (!application) {
  <loading-indicator [loadingMessage]="'Loading loan summary, please wait...'"></loading-indicator>
}
@if (application) {
<div>
  <div class="container-fluid px-0">
    <div class="card">
      <div class="card-body">
        <div class="row g-3">
          @if (borrowers && borrowers.length >= 1) {
            <div class="col-xs-6 col-sm-6">
              <tpo-borrower [borrowers]="borrowers"></tpo-borrower>
            </div>
          }
          <div class="col-xs-6 col-sm-6">
            <div class="card tpo-report-card h-100 mb-0 d-flex flex-column">
              <div class="card-body d-flex align-items-center flex-grow-1">
                <div class="panel-group w-100">
                  <div class="row align-items-stretch">
                    <div class="col-md-6 col-sm-6 col-xs-6"
                      [ngClass]="application ? 'border-end border-right-loan-status' : 'col-md-12'">
                      <loan-status-card
                        [loanStatusName]="loanStatus?.tpoStatusAlias || loanStatus?.loanStatusName || 'Unknown'">
                      </loan-status-card>
                    </div>
                    @if (application) {
                      <div class="col-md-6 col-sm-6 col-xs-6">
                        <outstanding-conditions-card [appId]="application.applicationId" [isTpoSubmitted]="isTpoSubmitted"
                          [primaryBorrowerId]="application.primaryBorrowerId">
                        </outstanding-conditions-card>
                      </div>
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-xs-12 col-sm-12">
            @if (application) {
              <tpo-loan-detail-reverse [application]="application" [mortgage]="mortgage"
                [mortgageCalculationDetails]="mortgageCalculationDetails"></tpo-loan-detail-reverse>
            }
          </div>
        </div>
        <div class="row g-3">
          @if (!(isPRMG && application?.channel === 'Correspondent')) {
            <div class="col-xs-6 col-sm-6">
              <div class="card tpo-report-card">
                <div class="card-header">
                  <h4 class="card-title"> <i class="far fa-file-alt"></i> Closing Info </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="form-group col-md-4 col-sm-6 col-xs-6">
                      <h5 class="mt-0 mb-1">{{application.estimatedClosingDate ? (application.estimatedClosingDate | date:
                        'MM/dd/yy') : '---'}}</h5>
                      <span class="text-secondary">Estimated Closing Date</span>
                    </div>
                    <div class="form-group col-md-4 col-sm-6 col-xs-6">
                      <h5 class="mt-0 mb-1">{{application.closingDate ? (application.closingDate | date: 'MM/dd/yy') :
                        '---'}}</h5>
                      <span class="text-secondary">Closing Date</span>
                    </div>
                    <div class="form-group col-md-4 col-xs-12">
                      <h5 class="mt-0 mb-1">{{application.fundingDate ? (application.fundingDate | date: 'MM/dd/yy') :
                        '---'}}</h5>
                      <span class="text-secondary">Funding Date</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}
